/*
This file is located in the main branch
Last time the file was updated (UTC): [11.12.2024 08:50:34]
Permissions to update outside the main branch: [false]
*/

import {
    DropDown,
    DynamicListRowWrapperDefault,
    useUpdateEffect,
    ValidatedDynamicList,
    ValidatedDynamicListFormComponentProps,
    ValidatedInput,
} from '@finbeat/react-toolkit';
import { TradeOrgSettingInfo } from 'models/api/tradeOrg';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { TradeOrgAddForm } from './TradeOrgChangeModal';
import { TradeOrgSettingsForm, TradeOrgSettingsFormWrapper } from './TradeOrgSettings';

type TradeOrgChangeModalSettingsProps = {
    settingTypes: DropDown[];
    settingTypesFetching: boolean;
    formHasRole: boolean;
};

const TradeOrgChangeModalTabSettings = ({
    settingTypes,
    settingTypesFetching,
    formHasRole,
}: TradeOrgChangeModalSettingsProps) => {
    const { t } = useTranslation();
    const { watch, setValue } = useFormContext<TradeOrgAddForm>();
    const useDefaultSettings = watch('settings.isUseDefault');

    useUpdateEffect(() => {
        setValue('settings.list', [{ id: null, type: '', value: '' }]);
    }, [useDefaultSettings]);

    const formComponent = useCallback(
        (props: ValidatedDynamicListFormComponentProps) => (
            <TradeOrgSettingsForm
                {...props}
                settingTypes={settingTypes}
                settingTypesFetching={settingTypesFetching}
                formHasRole={formHasRole}
            />
        ),
        [settingTypes, settingTypesFetching, formHasRole]
    );

    return (
        <>
            <ValidatedInput<TradeOrgAddForm>
                id="isUseDefault"
                className="my-3"
                type="checkbox"
                name="settings.isUseDefault"
                label={t('BackOfficeUseDefaultSettings')}
                disabled={!formHasRole}
            />
            {!useDefaultSettings && (
                <Row>
                    <Col>
                        <ValidatedDynamicList<TradeOrgAddForm, TradeOrgSettingInfo>
                            formComponent={formComponent}
                            wrapper={TradeOrgSettingsFormWrapper}
                            emptyRecord={{
                                id: null,
                                type: '',
                                value: '',
                            }}
                            name="settings.list"
                            prepend={false}
                            compareFunc={(a, b) => a?.type === b?.type}
                            rowWrapper={(props) => (
                                <DynamicListRowWrapperDefault
                                    {...props}
                                    disabled={props.disabled || props.idx === 0}
                                />
                            )}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

export default TradeOrgChangeModalTabSettings;
